// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImportResume_wrapper__3YIwZ"};